module.exports = __webpack_public_path__ + "static/media/guardar.80d69428.svg";